import React, { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import CrystalGoogleButton from "../components/CrystalGoogleButton";
import { useAuth } from "../context/AuthContext";

export default function LoginPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const { authenticated, loading: authLoading, onLoginSuccess } = useAuth();
  const [loading, setLoading] = useState(false);
  const [consentChecked, setConsentChecked] = useState(false);

  // Redirection automatique si déjà connecté
  useEffect(() => {
    if (!authLoading && authenticated) {
      const from = location.state?.from || "/hub";
      navigate(from, { replace: true });
    }
  }, [authenticated, authLoading, navigate, location]);

  const handleGoogleSuccess = async (tokenResponse) => {
    setLoading(true);
    try {
      const body = {};
      if (tokenResponse.credential) {
        body.id_token = tokenResponse.credential;
      } else if (tokenResponse.access_token) {
        body.access_token = tokenResponse.access_token;
      }

      const res = await fetch("/api/auth/login/google", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body)
      });
      const data = await res.json();
      if (data.status === "success") {
        await onLoginSuccess();
        // Le useEffect gère la redirection une fois authenticated = true
      } else {
        alert("Erreur Connexion: " + data.message);
        setLoading(false);
      }
    } catch (err) {
      alert("Erreur connexion Google");
      setLoading(false);
    }
  };

  if (authLoading || loading) {
    return (
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh", backgroundColor: "#000", color: "#0ff" }}>
        <div style={{ fontSize: "1.5rem" }}>Authentification en cours...</div>
      </div>
    );
  }

  return (
    <div style={{ textAlign: "center", padding: "60px 20px", color: "#fff", position: "relative", minHeight: "100vh", backgroundColor: "#000" }}>

      <Link to="/" style={{
        position: "absolute", top: "20px", left: "20px",
        color: "#666", textDecoration: "none", fontSize: "0.9rem",
        display: "flex", alignItems: "center", gap: "5px"
      }}>
        ← Retour Accueil
      </Link>

      <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "10px", marginTop: "40px" }}>
        <h1 style={{ fontSize: "3rem", marginBottom: "0", background: "linear-gradient(to right, #00f260, #0575E6)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent" }}>
          Portail d'Authentification
        </h1>
      </div>
      
      <div style={{ marginBottom: "40px" }}></div>
      <p style={{
        fontSize: "1.2rem", maxWidth: "600px", margin: "0 auto 40px", color: "#eee",
        background: "rgba(0, 0, 0, 0.6)", backdropFilter: "blur(4px)", padding: "15px", borderRadius: "10px", display: "inline-block"
      }}>
        Accès restreint à la plateforme Oracle d'Entropie Quantique. Veuillez vous identifier pour accéder au Hub applicatif.
      </p>

      <div style={{ background: "rgba(17, 17, 17, 0.75)", backdropFilter: "blur(12px)", padding: "30px", borderRadius: "12px", display: "inline-block", border: "1px solid #333" }}>
        <p style={{ marginBottom: "20px" }}>Authentification par identité Google requise.</p>

        {/* Checkbox Consentement Obligatoire */}
        <div style={{ marginBottom: "20px", fontSize: "0.85rem", color: "#ccc", textAlign: "left", maxWidth: "300px" }}>
          <label style={{ display: "flex", gap: "10px", alignItems: "start", cursor: "pointer" }}>
            <input
              type="checkbox"
              checked={consentChecked}
              onChange={(e) => setConsentChecked(e.target.checked)}
              style={{ marginTop: "3px" }}
            />
            <span>
              J'ai lu et j'accepte la <Link to="/privacy" target="_blank" style={{ color: "#0ff" }}>Politique de Confidentialité</Link>, les <Link to="/terms" target="_blank" style={{ color: "#0ff" }}>Conditions d'Utilisation</Link> et la <Link to="/retention-policy" target="_blank" style={{ color: "#0ff" }}>Politique de Rétention</Link>.
            </span>
          </label>
        </div>

        {/* Bouton Crystal Google */}
        <div style={{ display: "flex", justifyContent: "center" }}>
          <CrystalGoogleButton
            onSuccess={handleGoogleSuccess}
            onError={() => alert("Échec connexion Google")}
            disabled={!consentChecked}
          />
        </div>
      </div>
    </div>
  );
}
